import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectImageApi = createApi({
  reducerPath: "projectImageApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "projectImages",
  }),
  endpoints: (build) => ({
    tagTypes: ["Images"],
    uploadProjectImage: build.mutation({
      query: ({ uploadRequest, projectId }) => ({
        url: `${projectId}/uploadImage`,
        method: "POST",
        body: uploadRequest,
      }),
      async onQueryStarted({ projectId }, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { data: uploadedImage },
          } = await queryFulfilled;
          dispatch(
            projectImageApi.util.updateQueryData(
              "getProjectImages",
              { projectId: projectId },
              (images) => {
                images.push(uploadedImage);
              }
            )
          );
        } catch {
          console.error("error uploading project image");
        }
      },
    }),
    getProjectImages: build.query({
      query: ({ projectId }) => ({
        url: `${projectId}`,
      }),
      transformResponse: (response) => response.data,
      providesTags: ["Images"],
    }),
    removeProjectImage: build.mutation({
      query: ({ projectId, projectImageId }) => ({
        url: `${projectId}/removeImage/${projectImageId}`,
        method: "DELETE",
      }),
      async onQueryStarted({ projectId }, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { data: images },
          } = await queryFulfilled;
          dispatch(
            projectImageApi.util.updateQueryData(
              "getProjectImages",
              { projectId: projectId },
              () => images
            )
          );
        } catch {
          console.error("error removing project image");
        }
      },
    }),
    setDefaultProjectImage: build.mutation({
      query: ({ projectId, projectImageId }) => ({
        url: `${projectId}/setDefault/${projectImageId}`,
        method: "PATCH",
      }),
      async onQueryStarted({ projectId }, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { data: images },
          } = await queryFulfilled;
          dispatch(
            projectImageApi.util.updateQueryData(
              "getProjectImages",
              { projectId: projectId },
              () => images
            )
          );
        } catch {
          console.error("error setting default project image");
        }
      },
    }),
  }),
});

export const {
  useGetProjectImagesQuery,
  useRemoveProjectImageMutation,
  useUploadProjectImageMutation,
  useSetDefaultProjectImageMutation,
} = projectImageApi;
